import { Box, Container, Heading, List, ListIcon, ListItem, Text, VStack, Code } from '@chakra-ui/react'
import { FiCheck } from 'react-icons/fi'

export const ApiAccessOrgPage: React.FC = () => {
  return (
    <Container maxW="container.xl" py={8}>
      <VStack align="stretch" spacing={6}>
        <Box>
          <Heading as="h1" size="xl" color="brand.500" mb={3}>
            API: доступ и организация
          </Heading>
          <Text color="gray.600">
            Эндпоинты этой группы отвечают за вход, пользователей, роли и организационную структуру.
          </Text>
        </Box>

        <Box>
          <Heading size="md" mb={3}>Группы эндпоинтов</Heading>
          <List spacing={2}>
            <ListItem><ListIcon as={FiCheck} color="green.500" /><Code>/login</Code> — получение/обновление токена.</ListItem>
            <ListItem><ListIcon as={FiCheck} color="green.500" /><Code>/users</Code> — CRUD пользователей, роли, статусы.</ListItem>
            <ListItem><ListIcon as={FiCheck} color="green.500" /><Code>/org</Code> — организация, настройки и данные уровня компании.</ListItem>
          </List>
        </Box>
      </VStack>
    </Container>
  )
}
